<template>
  <div
    :class="[
      `alert rounded-md text-sm`,
      {
        'alert-error': theme === 'error',
        'alert-warning': theme === 'warning',
        'alert-info': theme === 'info',
        'alert-success': theme === 'success',
      },
    ]"
  >
    <div class="alert-content flex items-center">
      <div v-if="icon" class="flex-1 flex-grow-0 pr-3">
        <m-icon :icon="icon" :size="size" />
      </div>
      <div class="flex-1 flex-shrink-0">
        <slot name="title">
          <div v-if="title">
            <strong>{{ title }}</strong>
          </div>
        </slot>
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { MAlertProps } from '.';

  withDefaults(defineProps<MAlertProps>(), {
    title: undefined,
    theme: 'info',
    icon: undefined,
    size: '1x',
  });
</script>
